import { useState } from "react";
import { useNavigate } from "react-router";

import { Button, Grid2, Stack, Typography } from "@mui/material";
import { IconPlus } from "@tabler/icons-react";

import ResponsibleDepedentRegister from "./ResponsibleDepedentRegister";

const ResponsableDepedentList = ({
  depedents,
  refetch,
  responsableId,
}: any) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState<any>({ open: false, data: null, type: "" });

  const onClose = () => {
    setOpen({ open: false, data: null, type: "" });
  };

  return (
    <Stack spacing={2}>
      {open.type === "ADD" && (
        <ResponsibleDepedentRegister
          open={open.open}
          onClose={onClose}
          refetch={refetch}
          responsableId={responsableId}
        />
      )}
      <Stack
        flexDirection={"row"}
        alignItems={"flex-end"}
        justifyContent={"flex-end"}
      >
        <Button
          variant="contained"
          onClick={() =>
            setOpen((i: any) => ({ ...i, open: true, type: "ADD" }))
          }
        >
          <IconPlus />
          <Typography variant="subtitle1" fontWeight={700}>
            Adicionar aluno dependente
          </Typography>
        </Button>
      </Stack>
      <Grid2 container spacing={2}>
        {depedents?.map((student: any) => (
          <Grid2
            key={student?.id}
            size={12}
            sx={{
              flexDirection: "row",
              padding: 2,
              borderRadius: 4,
              alignItems: "center",
              backgroundColor: "secondary.main",
              gap: 1,
              cursor: "pointer",
            }}
            onClick={() => {
              navigate(`/students-details/${student.id}`);
            }}
          >
            <Stack
              justifyContent={"space-between"}
              flexDirection={"row"}
              alignItems={"center"}
            >
              <Stack>
                <Typography variant="body1" fontWeight={700}>
                  {student?.fullName}
                </Typography>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  fontWeight={700}
                >
                  {student?.nickName}
                </Typography>
              </Stack>
              <Stack bgcolor={"primary.main"} p={1} borderRadius={6}>
                <Typography variant="body2" fontWeight={700}>
                  Plano {student?.studentOnPlan[0]?.description}
                </Typography>
              </Stack>
            </Stack>
          </Grid2>
        ))}
      </Grid2>
    </Stack>
  );
};

export default ResponsableDepedentList;
